import http from "../redux/http";

export const getBlogsAPI = async (
  size,
  page,
  category,
  search,
  blog,
  author,
  tag,
  userId
) => {
  let params = {};
  if (size) params.size = size;
  if (page) params.page = page;
  if (category) params.category = category;
  if (search) params.search = search;
  if (blog) params.blog = blog;
  if (author) params.author = author;
  if (tag) params.tag = tag;
  if (userId) params.userId = userId;

  try {
    const { data } = await http.get("/blogs", {
      params,
    });

    return data.data;
  } catch (error) {
    return error;
  }
};

export const getBlogsAPI_v2 = async ({
  size,
  page,
  category,
  search,
  blog,
  author,
  tag,
  userId,
}) => {
  let params = {};
  if (size) params.size = size;
  if (page) params.page = page;
  if (category) params.category = category;
  if (search) params.search = search;
  if (blog) params.blog = blog;
  if (author) params.author = author;
  if (tag) params.tag = tag;
  if (userId) params.userId = userId;

  return await http.get("/blogs", {
    params,
  });
};

export const getBlogsBySlugAPI = async (blogSlug) => {
  let params = {};

  try {
    const { data } = await http.get(`/blogs/slug/${blogSlug}`, {
      params,
    });

    return data.data;
  } catch (error) {
    return error;
  }
};

export const getBlogsBySlugAPI_v2 = async (blogSlug) =>
  await http.get(`/blogs/slug/${blogSlug}`);

export const getBlogFollowersAPI = async ({ userId, size, page, type }) => {
  let params = {};
  if (size) params.size = size;
  if (page) params.page = page;
  if (type) params.type = type;

  return await http.get(`/users/${userId}/followers`, {
    params,
  });
};

export const followBlogAPI = async (blogId) =>
  await http.put(`/blogs/${blogId}/follows`);

export const unfollowBlogAPI = async (blogId) =>
  await http.delete(`/blogs/${blogId}/follows`);

export const followPhysicianAPI = async (userId) =>
  await http.put(`/users/${userId}/follows`);

export const unfollowPhysicianAPI = async (userId) =>
  await http.delete(`/users/${userId}/follows`);

export const createBlogAPI = async (body) => await http.post("/blogs", body);

export const updateBlogAPI = async ({ blogId, body }) =>
  await http.put(`/blogs/${blogId}`, body);
